/** Clock-synced sales film. Descriptors name the area on screen. */

export const FILM_TITLE = "REChecklist for Real Estate Professionals and the Dream Home Journey";
export const OVERLAY_S = 3.8;
export const OVERLAY_FADE = 0.4;
export const CHAOS_S = 19;
export const CHAOS_REUNION_AT = 12.2;
export const CHAOS_REUNION_HOLD = 4;
export const CHAOS_SHATTER_AT = 16.2;
export const CARD_S = 7;

export const CHAOS_FLASHES = [
  { text: "Sticky notes.", top: "12%", left: "7%", rotate: -7, at: 0.2, hold: 2.2 },
  { text: "Three calendars.", top: "24%", left: "58%", rotate: 5, at: 1.15, hold: 2.2 },
  { text: "Texts and emails.", top: "70%", left: "10%", rotate: -4, at: 2.1, hold: 2.2 },
  { text: "Half-finished apps.", top: "42%", left: "68%", rotate: 6, at: 3.05, hold: 2.2 },
  { text: "Call me back.", top: "8%", left: "36%", rotate: -2, at: 4.0, hold: 2.2 },
  { text: "Where's the file?", top: "56%", left: "46%", rotate: 3, at: 4.95, hold: 2.2 },
  { text: "Missed deadlines.", top: "34%", left: "14%", rotate: -6, at: 5.9, hold: 2.2 },
  { text: "Inspection tomorrow.", top: "76%", left: "60%", rotate: 2, at: 6.85, hold: 2.2 },
  { text: "Confused clients.", top: "50%", left: "5%", rotate: 4, at: 7.8, hold: 2.2 },
  { text: "Hours lost every week.", top: "16%", left: "40%", rotate: -5, at: 8.75, hold: 2.2 },
];

const FB = "main, .app-main, .site-main, .dashboard-frame, .landing-frame";
const SIDE_B = "[data-tour='buyer-sidebar']";
const SIDE_S = "[data-tour='seller-sidebar']";
const PASS_S = 7.2;
const BROKER_PASS_S = 8.6;
const CLOSE_S = 7;
const DESK = "[data-tour='desk-frame']";
const AUTH = "[data-tour='auth-card']";
const DESK_TITLE = ".page-header h1, .messages-desk h1, .desk-frame__body h1";

function pack(start, site, path, rows) {
  let at = start;
  const shots = rows.map((row) => {
    const hold = row.hold ?? 3;
    const shot = { site, path, fallback: FB, ...row, at };
    delete shot.hold;
    at += hold;
    return shot;
  });
  shots.end = at;
  return shots;
}

const REC_SUB = "Buyers, Seller, and Your Desk\nSeparate Accounts - United Purpose";
const JOURNEY_SUB = "Help for All Accounts - Your Authoritative Support Resources";

function board(id, title, url, sub) {
  return { id, hold: CARD_S, kind: "card", title, url, sub, camera: "full", line: "" };
}

function recBoard(id, title) {
  return board(id, title, "rechecklist.pro", REC_SUB);
}

function footerBeats(prefix, hero) {
  return [
    { id: `${prefix}-ir-nav`, hold: 3.4, selector: "[data-tour='nav-resources-main']", fallback: "[data-tour='nav-resources']", camera: "zoom-in", align: "start", line: "" },
    { id: `${prefix}-ir-side`, hold: 3.4, selector: "[data-tour='sidebar-resources']", fallback: SIDE_B, camera: "zoom-in", align: "start", line: "" },
    { id: `${prefix}-foot`, hold: 4, selector: "[data-tour='footer']", camera: "zoom-in", align: "start", action: "click", click: "[data-tour='nav-resources-main']", line: "" },
    { id: `${prefix}-foot-res`, hold: 3.2, selector: "[data-tour='footer-resources']", camera: "zoom-in", align: "start", wide: true, line: "" },
    { id: `${prefix}-foot-pages`, hold: 3.2, selector: "[data-tour='footer-pages']", camera: "zoom-in", align: "start", wide: true, line: "" },
    { id: `${prefix}-foot-contact`, hold: 4.2, selector: "[data-tour='footer-contact']", camera: "zoom-in", align: "start", tagLift: true, line: "" },
    { id: `${prefix}-top`, hold: 2, selector: hero, camera: "full", action: "top", line: "" },
  ];
}

const DESK_NAV = {
  start: "[data-tour='sidebar-start']",
  clients: "aside [data-tour='nav-client-manager']",
  prospects: "aside [data-tour='nav-prospects']",
  files: "aside [data-tour='nav-files']",
  docs: "aside [data-tour='nav-documents-photos']",
  inquiry: "aside [data-tour='nav-inquiry-response']",
  msg: "aside [data-tour='nav-client-messaging']",
  office: "aside [data-tour='nav-office-messaging']",
  cal: "aside [data-tour='nav-calendar']",
  settings: "aside [data-tour='nav-settings'], aside [data-tour='nav-profile-settings']",
  profile: "aside [data-tour='nav-profile']",
  archive: "aside [data-tour='nav-archive']",
  ret: "aside [data-tour='nav-retention']",
};

function deskPass(prefix, base, items, holdFor = PASS_S) {
  return items.flatMap((item) => {
    const path = `${base}${item.path}`;
    const pageSel = item.selector || DESK;
    const title = {
      id: `${prefix}-${item.id}`,
      hold: item.feature ? 3.4 : 3.8,
      path,
      selector: item.navSel || DESK_NAV[item.id] || DESK_TITLE,
      fallback: DESK_TITLE,
      camera: "zoom-in",
      align: "start",
      line: "",
      review: true,
      tight: true,
      clamp: "desk-nav",
    };
    if (!item.feature) return [title];
    return [
      title,
      {
        id: `${prefix}-${item.id}-feature`,
        hold: item.scan ? 11 : 6.8,
        path,
        selector: item.featureSel || pageSel,
        fallback: pageSel,
        camera: "zoom-in",
        align: "start",
        line: "",
        review: true,
        action: item.scan ? "scan" : undefined,
        scanMs: item.scanMs || 7200,
      },
    ];
  });
}

const intro = pack(0, "checklist", "/", [
  { ...recBoard("card-re", "REChecklist"), hold: 20 },
]);

const home = pack(intro.end, "checklist", "/", [
  { id: "home-full", hold: 5, selector: "[data-tour='re-home']", camera: "full", clamp: "landing", line: "" },
  { id: "home-purpose", hold: 7, selector: "[data-tour='re-purpose']", camera: "zoom-out", align: "start", clamp: "landing", line: "REChecklist" },
  { id: "home-signin", hold: 3, selector: "[data-tour='re-signin']", camera: "zoom-in", line: "" },
  { id: "home-buyer", hold: 3, selector: "[data-tour='re-buyer']", camera: "zoom-in", line: "" },
  { id: "home-seller", hold: 3, selector: "[data-tour='re-seller']", camera: "zoom-in", line: "" },
  { id: "home-dash", hold: CLOSE_S, selector: "[data-tour='re-dash']", camera: "zoom-in", close: true, line: "" },
]);

const dashCard = pack(home.end, "checklist", "/dashboard", [
  recBoard("card-dash", "Main Dashboard"),
]);

const dashboard = pack(dashCard.end, "checklist", "/dashboard", [
  { id: "dash-full", hold: 7, selector: "[data-tour='main-dash']", camera: "full", line: "" },
  { id: "dash-buyer", hold: 3.2, selector: "[data-tour='dash-buyer']", camera: "zoom-in", line: "" },
  { id: "dash-seller", hold: 3.2, selector: "[data-tour='dash-seller']", camera: "zoom-in", line: "" },
  { id: "dash-msg", hold: 3.2, selector: "[data-tour='dash-messages']", camera: "zoom-in", line: "" },
]);

const chaos = [
  {
    id: "chaos-desk",
    at: dashboard.end,
    site: "journey",
    path: "/demo/chaos",
    selector: "[data-tour='film-still']",
    camera: "full",
    line: "",
    kind: "chaos",
  },
];
chaos.end = dashboard.end + CHAOS_S;

const afterChaos = pack(chaos.end, "checklist", "/dashboard", [
  {
    id: "inset-handshake",
    hold: CLOSE_S,
    still: "/images/film/film-handshake.png",
    stillLine: "No More Chaos",
    stillLinger: true,
    close: true,
    selector: "[data-tour='main-dash']",
    camera: "full",
    line: "",
  },
]);

const buyerCard = pack(afterChaos.end, "checklist", "/start", [
  recBoard("card-buyer", "Buyer Checklist"),
]);

const buyerOpen = pack(buyerCard.end, "checklist", "/start", [
  { id: "buyer-hero", hold: 7, selector: "[data-tour='buyer-hero']", camera: "zoom-in", align: "start", line: "Welcome" },
  { id: "buyer-path", hold: 4, selector: "[data-tour='buyer-subnav']", camera: "zoom-in", align: "start", line: "Path" },
  { id: "buyer-side", hold: 6.5, selector: SIDE_B, camera: "zoom-in", align: "start", action: "scroll", scanMs: 5200, tag: "dock", line: "Sidebar" },
  { id: "buyer-notes", hold: 4, selector: SIDE_B, click: "[data-tour='sidebar-notes']", camera: "zoom-in", align: "start", zoom: 0.65, zoomKey: "dh_sidebar_zoom_v3", action: "click", tag: "dock", line: "Notes" },
  { id: "buyer-tips", hold: 4, selector: SIDE_B, click: "[data-tour='sidebar-tips']", camera: "zoom-in", align: "start", action: "click", tag: "dock", line: "Tips" },
  { id: "buyer-tx", hold: 3, selector: SIDE_B, click: "[data-tour='sidebar-transaction']", camera: "zoom-in", align: "start", action: "click", tag: "dock", line: "Tracker" },
  { id: "buyer-tx-zoom", hold: 3, selector: "[data-tour='txn-first']", fallback: SIDE_B, camera: "zoom-in", zoom: 0.65, zoomKey: "dh_sidebar_zoom_v3", tag: "dock", line: "Reminders" },
  { id: "buyer-tx-done", hold: 2, selector: "[data-tour='status-complete']", fallback: SIDE_B, camera: "zoom-in", action: "click", click: "[data-tour='status-complete']", tag: "dock", line: "Complete" },
  { id: "buyer-tx-prog", hold: 2, selector: "[data-tour='status-in_progress']", fallback: SIDE_B, camera: "zoom-in", action: "click", click: "[data-tour='status-in_progress']", tag: "dock", line: "In Progress" },
  { id: "buyer-tx-need", hold: 2, selector: "[data-tour='status-needs_attention']", fallback: SIDE_B, camera: "zoom-in", action: "click", click: "[data-tour='status-needs_attention']", tag: "dock", line: "Needs Attention" },
]);

const buyerLoc = pack(buyerOpen.end, "checklist", "/location", [
  { id: "buyer-loc", hold: 2.5, selector: "[data-tour='buyer-step']", camera: "full", zoom: 0.7, zoomKey: "dh_frame_zoom_v2", line: "Location" },
  { id: "buyer-loc-scan", hold: 8, selector: "[data-tour='buyer-step']", camera: "full", zoom: 0.7, zoomKey: "dh_frame_zoom_v2", action: "scan", scanMs: 6500, line: "" },
]);

const buyerLife = pack(buyerLoc.end, "checklist", "/lifestyle", [
  { id: "buyer-life", hold: 2.5, selector: "[data-tour='buyer-step']", camera: "full", zoom: 0.7, zoomKey: "dh_frame_zoom_v2", line: "Lifestyle" },
  { id: "buyer-life-scan", hold: 8, selector: "[data-tour='buyer-step']", camera: "full", zoom: 0.7, zoomKey: "dh_frame_zoom_v2", action: "scan", scanMs: 6500, line: "" },
]);

const buyerProgress = pack(buyerLife.end, "checklist", "/start", [
  { id: "buyer-mark-0", hold: 2, selector: "[data-tour='buyer-mark-0']", camera: "zoom-in", line: "" },
  { id: "buyer-mark-1", hold: 2, selector: "[data-tour='buyer-mark-1']", camera: "zoom-in", line: "" },
  { id: "buyer-mark-2", hold: 2, selector: "[data-tour='buyer-mark-2']", camera: "zoom-in", line: "" },
  { id: "buyer-mark-3", hold: 2, selector: "[data-tour='buyer-mark-3']", camera: "zoom-in", line: "" },
  { id: "buyer-mark-4", hold: 2, selector: "[data-tour='buyer-mark-4']", camera: "zoom-in", line: "" },
  ...footerBeats("buyer", "[data-tour='buyer-hero']"),
]);

const buyerClose = pack(buyerProgress.end, "checklist", "/start", [
  {
    id: "buyer-still",
    hold: CLOSE_S,
    selector: "[data-tour='buyer-hero']",
    camera: "full",
    line: "",
    still: "/images/film/film-buyers-smile.png",
    stillLine: "Buyer Experience Empowered!",
    stillLinger: true,
    close: true,
  },
]);

const sellerCard = pack(buyerClose.end, "checklist", "/seller/home", [
  recBoard("card-seller", "Seller Checklist"),
]);

const sellerOpen = pack(sellerCard.end, "checklist", "/seller/home", [
  { id: "seller-hero", hold: 7, selector: "[data-tour='seller-hero']", camera: "zoom-in", align: "start", line: "Seller Home" },
  { id: "seller-path", hold: 4, selector: "[data-tour='seller-subnav']", camera: "zoom-in", align: "start", line: "Path" },
  { id: "seller-side", hold: 6.5, selector: SIDE_S, camera: "zoom-in", align: "start", action: "scroll", scanMs: 5200, tag: "dock", line: "Sidebar" },
  { id: "seller-notes", hold: 4, selector: SIDE_S, click: "[data-tour='sidebar-notes']", camera: "zoom-in", align: "start", zoom: 0.65, zoomKey: "dh_sidebar_zoom_v3", action: "click", tag: "dock", line: "Notes" },
  { id: "seller-tips", hold: 3, selector: SIDE_S, click: "[data-tour='sidebar-tips']", camera: "zoom-in", align: "start", action: "click", tag: "dock", line: "Tips" },
  { id: "seller-tip-open", hold: 3.5, selector: "[data-tour='seller-tip-0']", fallback: SIDE_S, camera: "zoom-in", action: "click", click: "[data-tour='seller-tip-0']", tag: "dock", line: "Tips" },
  { id: "seller-ready", hold: 3, selector: SIDE_S, click: "[data-tour='sidebar-readiness']", camera: "zoom-in", align: "start", action: "click", tag: "dock", line: "Readiness" },
  { id: "seller-ready-scan", hold: 8, selector: SIDE_S, camera: "zoom-in", align: "start", action: "scan", scanMs: 6500, tag: "dock", line: "Readiness" },
]);

const sellerProp = pack(sellerOpen.end, "checklist", "/seller/property-details", [
  { id: "seller-prop", hold: 2.5, selector: "[data-tour='seller-frame']", fallback: FB, camera: "full", zoom: 0.7, zoomKey: "dh_frame_zoom_v2", line: "Property" },
  { id: "seller-prop-scan", hold: 8, selector: "[data-tour='seller-frame']", fallback: FB, camera: "full", zoom: 0.7, zoomKey: "dh_frame_zoom_v2", action: "scan", scanMs: 6500, line: "" },
]);

const sellerExt = pack(sellerProp.end, "checklist", "/seller/exterior-features", [
  { id: "seller-ext", hold: 2.5, selector: "[data-tour='seller-frame']", fallback: FB, camera: "full", zoom: 0.7, zoomKey: "dh_frame_zoom_v2", line: "Exterior" },
  { id: "seller-ext-scan", hold: 8, selector: "[data-tour='seller-frame']", fallback: FB, camera: "full", zoom: 0.7, zoomKey: "dh_frame_zoom_v2", action: "scan", scanMs: 6500, line: "" },
]);

const sellerProgress = pack(sellerExt.end, "checklist", "/seller/home", [
  { id: "seller-mark-0", hold: 2, selector: "[data-tour='seller-mark-0']", camera: "zoom-in", line: "" },
  { id: "seller-mark-1", hold: 2, selector: "[data-tour='seller-mark-1']", camera: "zoom-in", line: "" },
  { id: "seller-mark-2", hold: 2, selector: "[data-tour='seller-mark-2']", camera: "zoom-in", line: "" },
  { id: "seller-mark-3", hold: 2, selector: "[data-tour='seller-mark-3']", camera: "zoom-in", line: "" },
  { id: "seller-mark-4", hold: 2, selector: "[data-tour='seller-mark-4']", camera: "zoom-in", line: "" },
]);

const sellerClose = pack(sellerProgress.end, "checklist", "/seller/home", [
  {
    id: "seller-still",
    hold: CLOSE_S,
    selector: "[data-tour='seller-hero']",
    camera: "full",
    line: "",
    still: "/images/film/film-seller-relief.png",
    stillLine: "Listing with confidence",
    stillLinger: true,
    close: true,
  },
]);

const agentCard = pack(sellerClose.end, "checklist", "/agent/dashboard", [
  recBoard("card-agent", "Agent Desk"),
]);

const agent = pack(agentCard.end, "checklist", "/agent/dashboard", [
  { id: "agent-full", hold: 6, selector: "[data-tour='agent-desk']", fallback: AUTH, camera: "full", align: "start", action: "top", line: "" },
  { id: "agent-scan", hold: 8, selector: "[data-tour='agent-desk']", fallback: AUTH, camera: "full", action: "scan", scanMs: 6500, line: "" },
]);

const agentPassPacked = pack(
  agent.end,
  "checklist",
  "/agent/dashboard",
  deskPass("agent", "/agent", [
    { id: "start", path: "/start-here" },
    { id: "clients", path: "/clients", feature: true, featureSel: "[data-tour='desk-clients']" },
    { id: "prospects", path: "/prospects" },
    { id: "files", path: "/files" },
    { id: "docs", path: "/documents" },
    { id: "inquiry", path: "/responses" },
    { id: "msg", path: "/messages", selector: "[data-tour='messages-desk']", feature: true, featureSel: "[data-tour='messages-panes']" },
    { id: "office", path: "/office", selector: "[data-tour='messages-desk']" },
    { id: "cal", path: "/calendar", feature: true, featureSel: "[data-tour='calendar-options']", scan: true, scanMs: 7800 },
    { id: "settings", path: "/settings" },
  ])
);

const agentClose = pack(agentPassPacked.end, "checklist", "/agent/messages", [
  {
    id: "agent-still",
    hold: CLOSE_S,
    selector: "[data-tour='messages-desk']",
    fallback: DESK,
    camera: "full",
    line: "",
    still: "/images/film/film-overshoulder.png",
    stillLine: "Enhanced Communication = Less Stress",
    stillLinger: true,
    close: true,
  },
]);

const brokerCard = pack(agentClose.end, "checklist", "/broker/dashboard", [
  recBoard("card-broker", "Broker Desk"),
]);

const broker = pack(brokerCard.end, "checklist", "/broker/dashboard", [
  { id: "broker-full", hold: 7.5, selector: "[data-tour='broker-hero']", fallback: AUTH, camera: "full", align: "start", action: "top", line: "" },
  { id: "broker-scan", hold: 10, selector: "[data-tour='broker-hero']", fallback: AUTH, camera: "full", action: "scan", scanMs: 8000, line: "" },
  { id: "broker-hero", hold: 4.5, selector: "[data-tour='broker-hero']", fallback: AUTH, camera: "zoom-in", align: "start", line: "Your brokerage", tagTone: "pale" },
  { id: "broker-mine", hold: 5, selector: "[data-tour='broker-mine']", fallback: AUTH, camera: "zoom-in", line: "My Business", tagTone: "pale" },
  { id: "broker-office-pane", hold: 5, selector: "[data-tour='broker-office']", fallback: AUTH, camera: "zoom-in", line: "All Agents", tagTone: "pale" },
  { id: "broker-billing", hold: 4.5, selector: "[data-tour='broker-billing']", fallback: AUTH, camera: "zoom-in", line: "Office seats", tagTone: "pale" },
]);

const brokerPassPacked = pack(
  broker.end,
  "checklist",
  "/broker/dashboard",
  deskPass("broker", "/broker", [
    { id: "start", path: "/start-here" },
    { id: "clients", path: "/clients", feature: true, featureSel: "[data-tour='desk-clients']" },
    { id: "prospects", path: "/prospects" },
    { id: "files", path: "/files" },
    { id: "docs", path: "/documents" },
    { id: "inquiry", path: "/responses" },
    { id: "msg", path: "/messages", selector: "[data-tour='messages-desk']", feature: true, featureSel: "[data-tour='messages-panes']" },
    { id: "office", path: "/office", selector: "[data-tour='messages-desk']" },
    { id: "cal", path: "/calendar", feature: true, featureSel: "[data-tour='calendar-options']", scan: true, scanMs: 8000 },
    { id: "profile", path: "/profile" },
    { id: "settings", path: "/settings" },
    { id: "archive", path: "/messages/archive", selector: "[data-tour='messages-desk']" },
    { id: "ret", path: "/audit", selector: "[data-tour='retention']" },
  ], BROKER_PASS_S)
);

const brokerClose = pack(brokerPassPacked.end, "checklist", "/broker/audit", [
  {
    id: "broker-still",
    hold: CLOSE_S,
    selector: "[data-tour='retention']",
    fallback: DESK,
    camera: "full",
    line: "",
    still: "/images/film/film-celebrate.png",
    stillLine: "A calm closing",
    stillLinger: true,
    close: true,
  },
]);

const extraCard = pack(brokerClose.end, "checklist", "/broker/hub/hall", [
  board("card-extra", "Extra Features", "rechecklist.pro", "Dynamic Features for Brokers & Agents Included with Your Desk"),
]);

const convention = pack(extraCard.end, "checklist", "/broker/hub/hall", [
  { id: "hub-full", hold: 4, selector: "[data-tour='hub-hall']", fallback: DESK, camera: "full", line: "The Hub", tagTone: "pale" },
  { id: "hub-door-0", hold: 3.2, selector: "[data-tour='hub-door-0']", fallback: "[data-tour='hub-hall']", camera: "zoom-in", line: "Broker / Agent Chat", tagTone: "pale" },
  { id: "hub-door-1", hold: 3.2, selector: "[data-tour='hub-door-1']", fallback: "[data-tour='hub-hall']", camera: "zoom-in", line: "Associations", tagTone: "pale" },
  { id: "hub-door-2", hold: CLOSE_S, selector: "[data-tour='hub-door-2']", fallback: "[data-tour='hub-hall']", camera: "zoom-in", line: "City", tagTone: "pale", close: true },
]);

const journeyCard = pack(convention.end, "journey", "/", [
  board("card-journey", "DreamHome Journey", "dreamhomejourney.online", JOURNEY_SUB),
]);

const journeyHome = pack(journeyCard.end, "journey", "/", [
  { id: "jh-full", hold: 4, selector: "[data-tour='journey-home']", camera: "full", line: "" },
  { id: "jh-scan", hold: 12, selector: "[data-tour='journey-home']", camera: "full", action: "scan", scanMs: 10000, line: "" },
  { id: "jh-desk", hold: 3.2, selector: "[data-tour='journey-desk']", camera: "zoom-in", line: "The desk" },
  { id: "jh-porch", hold: 3.2, selector: "[data-tour='journey-porch-card']", camera: "zoom-in", line: "Support" },
  { id: "jh-buyers", hold: 3, selector: "[data-tour='journey-role-buyers']", camera: "zoom-in", line: "Buyers" },
  { id: "jh-sellers", hold: 3, selector: "[data-tour='journey-role-sellers']", camera: "zoom-in", line: "Sellers" },
  { id: "jh-agents", hold: 3, selector: "[data-tour='journey-role-agents']", camera: "zoom-in", line: "Agents" },
  { id: "jh-brokers", hold: CLOSE_S, selector: "[data-tour='journey-role-brokers']", camera: "zoom-in", line: "Brokers", close: true },
]);

const whyCard = pack(journeyHome.end, "journey", "/why-rechecklist", [
  board("card-why", "Why REChecklist", "dreamhomejourney.online", JOURNEY_SUB),
]);

const journey = pack(whyCard.end, "journey", "/why-rechecklist", [
  { id: "journey-why", hold: 5, selector: "[data-tour='why-desk']", camera: "zoom-in", line: "Why REChecklist" },
  { id: "journey-why-full", hold: 5, selector: "[data-tour='why-desk']", camera: "full", line: "" },
  { id: "journey-why-learn", hold: CLOSE_S, selector: "[data-tour='why-learn']", camera: "zoom-in", line: "Learn More", close: true },
]);

const manualsCard = pack(journey.end, "journey", "/manuals", [
  board("card-manuals", "User Manuals", "dreamhomejourney.online", JOURNEY_SUB),
]);

const manuals = pack(manualsCard.end, "journey", "/manuals", [
  { id: "journey-manuals", hold: 5, selector: "[data-tour='manuals']", camera: "zoom-in", line: "Manuals" },
  { id: "journey-manuals-full", hold: 4, selector: "[data-tour='manuals']", camera: "full", line: "" },
  { id: "journey-manuals-links", hold: CLOSE_S, selector: "[data-tour='manuals-links']", fallback: "[data-tour='manuals']", camera: "zoom-in", line: "Learn More", close: true },
]);

const supportCard = pack(manuals.end, "journey", "/support", [
  board("card-support", "Support", "dreamhomejourney.online", JOURNEY_SUB),
]);

const SUPPORT_LINE = "Your Full Support Index is Here";

const support = pack(supportCard.end, "journey", "/support", [
  {
    id: "journey-support",
    hold: 5.5,
    selector: "[data-tour='support-page']",
    fallback: "article, .site-main",
    camera: "full",
    align: "start",
    action: "top",
    tag: "story",
    line: SUPPORT_LINE,
  },
  {
    id: "journey-support-nav",
    hold: 3.5,
    selector: "[data-tour='nav-support']",
    fallback: "[data-tour='support-page']",
    camera: "zoom-in",
    align: "start",
    action: "top",
    line: "",
  },
  {
    id: "journey-support-ccm",
    hold: 4,
    selector: "[data-tour='support-page']",
    fallback: "article, .site-main",
    camera: "full",
    align: "start",
    action: "top",
    tag: "story",
    line: "Confidence. Clarity. Momentum.",
  },
  {
    id: "journey-support-glide",
    hold: 16,
    selector: "[data-tour='support-door-0']",
    fallback: "[data-tour='support-index']",
    camera: "zoom-in",
    action: "glide",
    glide: [
      "[data-tour='support-door-0']",
      "[data-tour='support-door-1']",
      "[data-tour='support-door-2']",
      "[data-tour='support-door-3']",
      "[data-tour='support-door-4']",
      "[data-tour='support-door-5']",
      "[data-tour='support-door-6']",
      "[data-tour='support-door-7']",
      "[data-tour='support-write']",
    ],
    expandAt: 8,
    line: "",
  },
  {
    id: "journey-support-close",
    hold: 3.5,
    selector: "[data-tour='support-page']",
    fallback: "article, .site-main",
    camera: "full",
    line: "",
    close: true,
  },
]);

const communityCard = pack(support.end, "journey", "/community", [
  board("card-community", "Community", "dreamhomejourney.online", JOURNEY_SUB),
]);

const community = pack(communityCard.end, "journey", "/community", [
  {
    id: "community-full",
    hold: 6,
    selector: "[data-tour='community-page']",
    fallback: "article, .site-main",
    camera: "full",
    tag: "story",
    line: "Community links to your Professional, Live Bulletin Board System (BBS)",
  },
  {
    id: "community-nav",
    hold: 3.5,
    selector: "[data-tour='nav-community']",
    fallback: "[data-tour='community-page']",
    camera: "zoom-in",
    line: "",
  },
  {
    id: "community-close",
    hold: 6,
    selector: "[data-tour='community-page']",
    fallback: "article, .site-main",
    camera: "full",
    line: "",
    close: true,
  },
]);

const closeDash = pack(community.end, "checklist", "/dashboard", [
  { id: "credits", hold: 16, selector: "[data-tour='main-dash']", camera: "full", line: "", credits: true },
]);

const thanksCard = pack(closeDash.end, "checklist", "/", [
  board("card-thanks", "Thank You for Viewing", "rechecklist.pro", "Built for You."),
]);

const closeHome = pack(thanksCard.end, "checklist", "/", [
  { id: "landing", hold: 12, selector: "[data-tour='re-home']", camera: "full", line: "REChecklist", end: true },
]);

export const SHOTS = [
  ...intro,
  ...home,
  ...dashCard,
  ...dashboard,
  ...chaos,
  ...afterChaos,
  ...buyerCard,
  ...buyerOpen,
  ...buyerLoc,
  ...buyerLife,
  ...buyerProgress,
  ...buyerClose,
  ...sellerCard,
  ...sellerOpen,
  ...sellerProp,
  ...sellerExt,
  ...sellerProgress,
  ...sellerClose,
  ...agentCard,
  ...agent,
  ...agentPassPacked,
  ...agentClose,
  ...brokerCard,
  ...broker,
  ...brokerPassPacked,
  ...brokerClose,
  ...extraCard,
  ...convention,
  ...journeyCard,
  ...journeyHome,
  ...whyCard,
  ...journey,
  ...manualsCard,
  ...manuals,
  ...supportCard,
  ...support,
  ...communityCard,
  ...community,
  ...closeDash,
  ...thanksCard,
  ...closeHome,
];

export const FILM_LENGTH = closeHome.end;

export function shotIndexAt(elapsed) {
  let index = 0;
  SHOTS.forEach((shot, i) => {
    if (elapsed >= shot.at) index = i;
  });
  return index;
}

export function fadeInOut(age, duration, fade = OVERLAY_FADE) {
  if (age <= 0) return 0;
  if (age < fade) return age / fade;
  if (age > duration - fade) return Math.max(0, (duration - age) / fade);
  return 1;
}

export function flashOpacity(flash, age, fade = 0.9) {
  const start = flash.at;
  const end = flash.at + fade + flash.hold + fade;
  if (age < start || age > end) return 0;
  const local = age - start;
  if (local < fade) return local / fade;
  if (local > fade + flash.hold) return Math.max(0, 1 - (local - fade - flash.hold) / fade);
  return 1;
}
